import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-sheet',
  templateUrl: './help-sheet.component.html',
  styleUrls: ['../help.content.css']
})
export class HelpSheetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
